import { createApi } from '@reduxjs/toolkit/query/react';

import { createBaseQuery } from '@verantos-dev/core-utils';

export const baseApiV2 = createApi({
  reducerPath: 'baseApiV2',
  baseQuery: createBaseQuery({ version: 'v2' }),
  endpoints: () => ({}), // inject endpoints at the feature level
});
